var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9645 17.3501C2.0094 16.4276 1.24758 15.3242 0.723489 14.1042C0.199399 12.8841 -0.0764632 11.5719 -0.0880013 10.2441C-0.0995395 8.91633 0.153477 7.59953 0.656286 6.37057C1.1591 5.1416 1.90163 4.02509 2.84055 3.08616C3.77948 2.14723 4.896 1.4047 6.12496 0.901892C7.35393 0.399083 8.67072 0.146066 9.99852 0.157604C11.3263 0.169142 12.6385 0.445005 13.8585 0.969095C15.0786 1.49318 16.182 2.25501 17.1045 3.21011C18.9261 5.09613 19.934 7.62215 19.9112 10.2441C19.8885 12.8661 18.8368 15.3742 16.9827 17.2283C15.1286 19.0824 12.6205 20.1341 9.99852 20.1568C7.37655 20.1796 4.85052 19.1717 2.9645 17.3501ZM15.6945 15.9401C17.1956 14.439 18.039 12.403 18.039 10.2801C18.039 8.1572 17.1956 6.12123 15.6945 4.62011C14.1934 3.11898 12.1574 2.27566 10.0345 2.27566C7.91159 2.27566 5.87563 3.11898 4.3745 4.62011C2.87338 6.12123 2.03005 8.1572 2.03005 10.2801C2.03005 12.403 2.87338 14.439 4.3745 15.9401C5.87563 17.4412 7.91159 18.2846 10.0345 18.2846C12.1574 18.2846 14.1934 17.4412 15.6945 15.9401ZM6.7345 9.57011L9.0345 11.8801L13.3345 7.58011L14.7345 9.00011L9.0345 14.6801L5.3345 10.9801L6.7345 9.56011V9.57011Z",
    fill: "#78A22F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFillIcon);
export default __webpack_public_path__ + "static/media/CheckCircleFillIcon.84d6d5b9c62483bd2e534dcad096ea2d.svg";
export { ForwardRef as ReactComponent };